import { AlertWarningCircleIcon } from '@calendly/ui/components/icons'
import { colorIconWarning } from '@calendly/ui/theme'

import {
  SendFromDropdownBrandLogo,
  SendFromDropdownGmailLogo,
  SendFromDropdownOutlookLogo,
} from '../send_from_brand_logo'

const logoNames = {
  gmail: 'gmail',
  outlook: 'microsoft-outlook',
  calendly: 'calendly'
}

export const SendFromOptionIcon = ({ option }) => {
  if (!option.type) return null
  if (option.accessGranted) {
    if (option.type === 'gmail') {
      return <SendFromDropdownGmailLogo />
    }

    if (option.type === 'outlook') {
      return <SendFromDropdownOutlookLogo />
    }

    return (
      <SendFromDropdownBrandLogo
        name={logoNames[option.type]}
        title={option.type}
      />
    )
  }

  return <AlertWarningCircleIcon size="standard" color={colorIconWarning} />
}
